import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { setupTokenRefresh, clearTokenRefresh } from '../utils/tokenRefresh';
import { setupVersionCheck, clearVersionCheck } from '../utils/versionCheck';
import { registerPushNotification } from '../utils/pushNotification';

// ログインが不要なパス
const PUBLIC_PATHS = ['/login'];

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const refreshIntervalRef = useRef(null);
  const versionCheckIntervalRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    // 現在のパスがログイン不要なパスの場合はチェックをスキップ
    if (PUBLIC_PATHS.includes(location.pathname)) {
      return;
    }

    // 認証トークンをチェック
    const token = Cookies.get('auth_token');
    
    if (!token) {
      // トークンがない場合はログインページへリダイレクト
      navigate('/login', { replace: true });
    } else if (!isInitialized.current) {
      // 初回のみトークンリフレッシュとバージョンチェックを設定
      isInitialized.current = true;
      refreshIntervalRef.current = setupTokenRefresh(5);
      versionCheckIntervalRef.current = setupVersionCheck(5);
      // プッシュ通知を登録（ユーザーが許可すれば有効になる）
      registerPushNotification();
    }

    // クリーンアップ関数
    return () => {
      if (refreshIntervalRef.current) {
        clearTokenRefresh(refreshIntervalRef.current);
        refreshIntervalRef.current = null;
        isInitialized.current = false;
      }
      if (versionCheckIntervalRef.current) {
        clearVersionCheck(versionCheckIntervalRef.current);
        versionCheckIntervalRef.current = null;
      }
    };
  }, [navigate, location.pathname]);

  return children;
}

export default ProtectedRoute;
